import themeUtils from '../themeUtils';
import ProductListItem from '../components/ProductListItem';
import Flickity from 'flickity';

export default class DynamicFeaturedCollection {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this._flickity = this._flickity.bind(this);
    this._destroyFlickity = this._destroyFlickity.bind(this);
    this.$window = $(window);
    this.productViews = [];
    this.$container = this.$el.find('[data-products-container]');
    this.slide = '.product-list-item';
    this.flickity = null;

    this._bindEvents();
    this._setupProducts();
    this._flickity();
  }

  onSectionUnload() {
    this.$window.off('resize.home-featured-collections');

    this._destroyFlickity();

    if (this.productViews.length) {
      // Destroy existing view listeners
      this.productViews.map((productView) => {
        productView.remove();
      });
    }
  }

  _bindEvents() {
    this.$window.on('resize.home-featured-collections', themeUtils.debounce(this._flickity, 100));
  }

  _setupProducts() {
    $('.product-list-item', this.$el).each((index, productItem) => {
      this.productViews.push(new ProductListItem({ el: productItem }));
    });
  }

  _flickity() {
    if (!this.$container.length) { return; }

    // If larger than 'small', destroy Flickity and exit
    if (!themeUtils.isSmall()) {
      this._destroyFlickity();
      return;
    }

    // If Flickity is initialised, exit
    if (this.flickity) {
      return;
    }

    this.flickity = new Flickity(this.$container[0], {
      cellAlign: 'left',
      cellSelector: this.slide,
      contain: false,
      prevNextButtons: false,
      pageDots: false,
      setGallerySize: false,
    });

    this._flickityEvents();
  }

  _destroyFlickity() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;

      this.$window.off('resize.home-featured-collections-flickity');
      this.$container.off('home-featured-collections-height');
      this.$container.off('rimg:load');
    }
  }

  _flickityEvents() {
    // Check for tallest slide at start of transition
    this.flickity.on('cellSelect', () => {
      this.$container.trigger('home-featured-collections-height');
    });

    // Check for tallest slide at end of transition
    this.flickity.on('settle', () => {
      this.$container.trigger('home-featured-collections-height');
    });

    if (this.flickity) {
      this.$container.on('rimg:load', () => {
        themeUtils.flickityResize(this.flickity);
      });
    }

    this.$container.on('home-featured-collections-height', () => {
      themeUtils.flickityResize(this.flickity);
    });

    // Sets the Slider to the height of the first slide
    this.$container.trigger('home-featured-collections-height');

    this.$window.on(
      'resize.home-featured-collections-flickity',
      themeUtils.debounce(() => this.$container.trigger('home-featured-collections-height'), 10),
    );
  }
}
